"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("./types");
function unparseDiagram(diagramData) {
    const diagram = diagramData;
    const actors = new Map();
    diagram.actors.forEach((actor) => actors.set(actor.id, actor));
    const resolveActors = (action) => {
        if (action.caller)
            action.caller = actors.get(action.caller);
        if (action.callee)
            action.callee = actors.get(action.callee);
        if (action.children)
            action.children.forEach((child) => resolveActors(child));
    };
    diagram.rootActions.forEach((action) => (0, types_1.setParent)(action));
    diagram.rootActions.forEach((action) => resolveActors(action));
    return diagram;
}
exports.default = unparseDiagram;
